import { getCartProductMarkup } from '@archetype-themes/modules/cart';

document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.add-suggestion-btn');
    if (!btn) return;

    let variantId = btn.getAttribute('data-variant-id');

    const wrapper = btn.closest('.cart__suggestion-item');

    if (!variantId) {
        const select = wrapper?.querySelector('.variant-dropdown');
        if (select) {
            variantId = select.value;
        }
    }

    if (!variantId) {
        console.warn('No variant ID found for recommendation add');
        return;
    }

    let quantity = 1;
    const quantityInput = wrapper?.querySelector('.recommendation-quantity-input');
    if (quantityInput) {
        const parsed = parseInt(quantityInput.value, 10);
        if (!isNaN(parsed) && parsed > 0) {
            quantity = parsed;
        }
    }

    btn.disabled = true;
    btn.textContent = 'Adding...';

    try {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity }),
        });

        if (res.ok) {
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

            // Fetch updated cart HTML
            const cartDrawer = document.querySelector('header-cart-drawer');
            const container = cartDrawer?.querySelector('[data-products]');

            if (container) {
                getCartProductMarkup().then((html) => {
                    const temp = document.createElement('div');
                    temp.innerHTML = html;

                    const newContent = temp.querySelector('[data-products]');
                    if (newContent) container.innerHTML = newContent.innerHTML;
                });
            }

            // Update item count in subtotal label & cart drawer title
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    const itemLabel = document.querySelector('.cart__item--subtotal-label');
                    if (itemLabel) {
                        itemLabel.textContent = `Subtotal (${cart.item_count} Item${cart.item_count === 1 ? '' : 's'})`;
                    }

                    const cartHeader = document.querySelector('.cart__tools p');
                    if (cartHeader) {
                        const label = cartHeader.textContent.split('(')[0].trim(); // get prefix before (
                        cartHeader.textContent = `${label} (${cart.item_count})`;
                    }
                })
                .catch(err => console.error('Failed to update item count:', err));

            btn.textContent = 'Added';
        } else {
            btn.textContent = 'Error';
        }
    } catch (err) {
        console.error(err);
        btn.textContent = 'Error';
    } finally {
        setTimeout(() => {
            btn.disabled = false;
            btn.textContent = '+ ADD';
        }, 2000);
    }
});